module.exports = __webpack_public_path__ + "images/trust-pilot-c23b1f5acb320412f330f41031004f4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/trust-pilot.png
// module id = 6+q0
// module chunks = 0